<!-- Container to inject the Sign-In Widget -->
<!-- <div id="okta-signin-container"></div> -->

<div class="engie-login">
  <div class="engie-accesos">
        <div class="container">
              <div class="row items-accesos">
                <div class="box-login">
                  <h3>PORTAL DE GESTIÓN DE</h3>
                  <h2>TERCEROS</h2>
                </div>
              </div>
        </div>
  </div>

</div>
<div class="engie-form">
  <div class="engie-accesos">
    <div class="row">
      <div class="engie-datos">
        <div class="row">
          <div class="col-md-12">
            <img class="engie-q1" src="./assets/img/Logo_w.svg">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h3 class="engie-q2">Login</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>CORREO</mat-label>
              <input matInput type="email" [(ngModel)]="model.email" />
            </mat-form-field>            
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>CONTRASEÑA</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" [(ngModel)]="model.password" />
              <button
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide"
              >
                <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>        
        <div class="row">
          <div class="col-md-7" *ngIf="displayError">
            <p style="text-align: left;"><a class="engie-login-enlace">Correo o contraseña invalidas</a></p>
          </div> 
        </div>        
        <div class="row">
          <!-- <div class="col-md-6">
            <mat-selection-list>
              <mat-list-option class="engie-login-check">Recordar</mat-list-option>
            </mat-selection-list>
          </div> -->
          <div class="col-md-12">
            <p style="text-align: right;"><a class="engie-login-enlace" [routerLink]="['/recuperar-contrasena']">Olvidé mi contraseña</a></p>
          </div> 
          <div class="col-md-12 pad-25">
            <button class="btn btn-azul" mat-button (click)="login(2)" cdkFocusInitial>Ingresar</button>
            <!-- <button class="btn btn-blanco" mat-button (click)="login(1)">Ingresar como Engie QA</button> -->
            <button class="btn btn-blanco" mat-button (click)="loginOkta()">Ingresar como Engie</button>
          </div>       
          <!-- <div class="col-md-12">
            <p style="text-align: center;"><a class="engie-login-enlace engie-cambiar-clave" [routerLink]="['/restablecer-contrasena']">Cambiar mi contraseña</a></p>
          </div>             -->
        </div>  
      </div>
    </div>
  </div>

</div>

<!-- <pre>{{model | json}}</pre> -->